import { useStaticQuery, graphql } from 'gatsby'

export interface SiteProp {
  display_name: string
  short_name: string
  brand_organization: string
  default_company: string
  default_support_email: string
  default_sales_email: string
  default_phone_number: string
  default_company_address: string
  default_country_id: number
  default_resume_product: string
  time_zone: string
  locale: string
  language: string
  site_id: number
  banner_text: string
  banner_cta_text: string
  banner_cta_link: string
}

export default function useSiteData(): SiteProp {
  const { talentIncSite } = useStaticQuery<{
    talentIncSite: SiteProp
  }>(
    graphql`
      query UseSiteData {
        talentIncSite {
          display_name
          short_name
          brand_organization
          default_company_email
          default_company
          default_support_email
          default_sales_email
          default_phone_number
          default_company_address
          default_resume_product
          default_country_id
          time_zone
          locale
          language
          site_id
        }
      }
    `
  )
  return talentIncSite
}
